/**
 * 'stu' 生徒；
 * 'tea' 教員
 * 'adm' 管理者
 * 'op' 運営
 * 'op_a' 運営アルバイト;
 */
export enum UserType {
  'stu',
  'tea',
  'adm',
  'op',
  'op_a',
}
export const userTypeData = {
  stu: 'stu',
  tea: 'tea',
  adm: 'adm',
  op: 'op',
  op_a: 'op_a',
};
export const userTypes = [
  { type: 'stu', typeName: '生徒', connectOperationPage: false },
  { type: 'tea', typeName: '先生', connectOperationPage: false },
  { type: 'adm', typeName: '管理者', connectOperationPage: true },
  { type: 'op', typeName: '運営', connectOperationPage: true },
  { type: 'op_a', typeName: '運営アルバイト', connectOperationPage: true },
];

export const userTypeOptions = userTypes.map((d) => {
  return { title: d.typeName, value: d.type };
});

export const adminUserTypeOptions = userTypes
  .filter((d) => d.connectOperationPage)
  .map((d) => {
    return { title: d.typeName, value: d.type };
  });
